// extracted by mini-css-extract-plugin
export default {"registration":"style_registration__bqA0z"};